module.exports = __webpack_public_path__ + "static/education-resources-3-cc6d2c50ba1519874543b1bf010c0eff.jpg";